export const summaryCardDocumentsParser = values => {
  return values
    ? values.map(item => {
        const { name, path, publicationDate, title } = item;

        if (item.path.includes('/generate-report/')) {
          return {
            name,
            title,
            path,
            publicationDate,
            options: {},
            retries: 14,
          };
        }

        return item;
      })
    : [];
};
